import { cn } from "../../lib/utils"
import { useLocation } from "react-router-dom";
import { useEffect, useRef } from "react";

export function Container({ children, className, ...props }) {
  const location = useLocation();
  const innerRef = useRef(null);

  useEffect(() => {
    const el = innerRef.current;
    if (!el) return;
    el.classList.remove("page-transition");
    void el.offsetWidth;
    el.classList.add("page-transition");
  }, [location.pathname]);

  return (
    <div
      className={cn(
        "mx-auto w-full max-w-screen-xl px-4 sm:px-6 lg:px-8",
        className
      )}
      {...props}
    >
      <div ref={innerRef} className="page-transition">
        {children}
      </div>
    </div>
  )
}
